import './Elements.css';
import React from 'react'
import{ Link } from 'react-router-dom'
import logos from './images/logos.jpg'

export default function Navbar() {
  return (
    <>
    <nav className="navbar navbar-expand-lg navbar-light bg-$light">
  <div className="container ">
 
    <Link className="navbar-brand" to="/about">
    <img src={logos} alt="" width="90" height="60"/>

    </Link>
   <ul className="nav justify-content-end">
    <div  >
          <li className="nav-item"> <form className="d-flex" role="search">
     <Link to="/form">   <button className="btn btn-outline-success" type="submit">Login/SignUp</button> </Link>
      </form></li>
    </div>
    </ul>
  </div>
</nav>
    </>
    
  )
}
